import loadableWithRetry from '../common/loadableWithRetry'

const RelatedListings = loadableWithRetry(() => import('./RelatedListings'))

export default RelatedListings;
